import type { ComponentOptions } from 'vue';
import type Vue from 'vue';
import type { VueClass } from 'vue-class-component/lib/declarations';
import { client } from 'rsui-core/lib/post-message';
import storageCacheManager from '@/library/cache/storageCacheManager';
import { CacheKeyType } from '@/library/cache/types';
import { IPSService } from '@/services/ipsServices';
import { EmpServiceAPIActions } from '@/services/empService';

const _ = require('lodash');
const hasValue = require('has-value');

/**
 *  注解的分发方法
 * @param componentFactory  注解的处理函数
 */
export function decoratorDispense(componentFactory) {
  return function Dispense(options?: ComponentOptions<Vue> | VueClass<Vue>) {
    if (typeof options === 'function') {
      return componentFactory(options);
    }
    return function(Component: VueClass<Vue>) {
      return componentFactory(Component, options);
    };
  };
}

// 脱敏处理

export function desensitize(value: string, type: string) {
  // 手机号脱敏处理
  if (type === 'phone') {
    return value.replace(/(\S{3})\d{4}(\d{4})/, '$1****$2');
  }
  if (type === 'idcard') {
    if (value.length === 18) {
      return value.replace(/(\d{6})\d{8}(\S{4})/, '$1********$2');
    } else if (value.length === 7) {
      return value.replace(/(\d*)\d{3}(\S{3})/, '$1***$2');
    } else {
      return value.replace(/(\d*)\d{4}(\S{3})/, '$1****$2');
    }

  }
  if (type === 'bankcard') {
    return value.replace(/(\d{7})\d{8}(\S{4})/, '$1********$2');
  }
  if (type === 'name') {
    if (value.length === 1) {
      return `*${value}`;
    } else {
      return new Array(value.length).join('*') + value.slice(-1);
    }
  }
}

export const numberToArray = (num: number): number[] => {
  return Array.from({ length: num }).map((v, i) => i + 1);
};

export function noop(a?, b?, c?) {
}

export function findIn(text: string, find: string): boolean {
  if (!text || !find) {
    return true;
  }
  const textToLocale = text.toLocaleUpperCase();
  const findToLocale = find.toLocaleUpperCase();

  if (textToLocale === findToLocale) {
    return true;
  }

  return textToLocale.includes(findToLocale);
}

export function debounce(func, wait: number) {
  let timeout;
  return function() {
    const content = this;
    const arg = arguments;
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      func.apply(content, arg);
    }, wait);
  };
}

export function throttle(func, wait) {
  let timeout;
  return function() {
    const context = this;
    const arg = arguments;

    timeout = setTimeout(() => {
      timeout = null;
      func.apply(context, arg);
    }, wait);
  };
}

export function toDecimal2(x) {
  let f = Number.parseFloat(x);
  if (Number.isNaN(f)) {
    return false;
  }
  f = Math.round(x * 100) / 100;
  let s = f.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}

/**
 * 数组扁平化
 * @param arr
 */
export function flatten(arr: any[]) {
  while (arr.some(item => Array.isArray(item))) {
    arr = [].concat(...arr);
  }
  return arr;
}

export function parseSec(a, date?) {
  const sDateTime = new Date(new Date(date).toLocaleDateString()).getTime();
  const sMonthTime = new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 60 * 60 * 1000;
  const eTime = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;// 当天时间23：59：59
  const yesterdayTime = new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000;// 昨天时间0：0：0
  switch (a) {
    case 1:
      // 目标时间0：00：00转化为秒级时间戳
      return Date.parse(new Date(sDateTime)) / 1000;
    case 2:
      // 目标时间23：59：59转化为秒级时间戳
      return Date.parse(new Date(sDateTime + 24 * 60 * 60 * 1000 - 1)) / 1000;
    case 3:
      // 一个月前的时间
      return new Date(sMonthTime);
    case 4:
      // 当天时间23：59：59
      return new Date(eTime);
    case 5:
      // 当天时间0：00：00
      return new Date(sDateTime);

    case 6:
      // 目标时间23：59：59
      return new Date(sDateTime + 24 * 60 * 60 * 1000 - 1);
    case 7:
      // 昨天时间0：00：00
      return yesterdayTime;
  }
}

export function moneyRevert(money) {
  return (
    `￥${Number(money)
      .toString()
      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
  );
}

// json转化为路由参数格式
export function JsonToUrlParam(json: {} = {}): string {
  return Object.keys(json)
    .map((key) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
    })
    .join('&');
}

// 功能只对瑞丽开放
export function showPlatform(data?) {
  const list = data ? data : ['really', 'devtest2'];
  const cacheCorpId = storageCacheManager.getItem(CacheKeyType.CACHE_FOR_CORPID);
  return !!list.includes(cacheCorpId.toLowerCase());
}

export function downloadIamge(imgsrc, name) {
  // 下载图片地址和图片名
  const image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous');
  image.onload = function() {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, image.width, image.height);
    const url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据

    const a = document.createElement('a'); // 生成一个a元素
    const event = new MouseEvent('click'); // 创建一个单击事件
    a.download = name || 'photo'; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgsrc;
}

export function getConditionText(id, siteId) {
  return new Promise((resolve) => {
    if (!id) {
      return;
    }
    IPSService.customerCondition({
      queryParams: {
        id,
        EXT_IPS__SITE: siteId ? siteId : '',
      },
    }).then((response) => {
      let length = 0;
      (response.conditions || []).forEach((val) => {
        const orLength = val.or ? val.or.length : 0;
        const andLength = val.and ? val.and.length : 0;
        length = length + orLength + andLength;
      });
      resolve(`已选择${length}个条件`);
    });
  });
}

export function setCondition(param) {
  const { siteId, sgId, id } = param;
  const tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };
  const protocol = `${location.protocol}//`;
  let hostName = location.hostname;
  hostName.includes('host') && (hostName = 'ips.maintenance.qingger.cn');
  return new Promise((resolve) => {
    IPSService.siteGroupConfig({
      postParams: {
        sgId,
        siteId,
      },
    }).then((res) => {
      client
        .pick({
          path: 'customer-predicate',
          dialogStyle: { width: '50vw', height: '100vh', backgroudColor: '#eee', zIndex: 99999999999 },
          modelDialog: true,
          slide: 'left',
          props: {
            params: { actId: res.actId || 2 },
            zIndex: 99999999999,
            id,
            exclude: ['#root.crmPublicAccounts'],
          },
          domain: `${protocol + hostName}/scrm/web`,
          cancel: true,
          search: `?baseURL=/nips/scrm&ext_ips__auth_token=${tokenData.Authorization}&ext_ips__site=${siteId}`,
        })
        .then((r: any) => {
          resolve(r);
        });
    });
  });
}

export namespace QinggerLibUtils {
  /**
   * 判断是否为空
   * @param val
   * @param {string} props
   * @returns {boolean}
   */
  export function empty(val: any, props: string = null): boolean {
    if (!val) {
      return true;
    }

    if (_.isNumber(val) || _.isString(val) || _.isBoolean(val)) {
      return !val;
    }

    return !hasValue(val, props);
  }

  /**
   * 判断变量是否被设置
   * @note : 空对象{}返回为false
   * @param val
   * @param {string} props
   */
  export function isset(val: any, props: string = null) {
    if (val == 0 || val == false) {
      // 固定值设置为true
      return true;
    }
    if (!val) {
      return false;
    }

    if (!props) {
      return !!val;
    } else {
      return !!val[props];
    }
  }

  /**
   * 判断元素是否在数组中存在
   * @param {T} search
   * @param {Array<T>} arr
   * @param {number} index
   * @return {boolean}
   */
  export function inArray<T = any>(search: T, arr: Array<T>, index = 0) {
    if (_.isArray(arr)) {
      return arr.includes(search, index);
    } else {
      return false;
    }
  }
}
